import { apiServer } from 'settings/web-services/api';

export function getExpandedUrl({ shortCode }) {
  return apiServer.get(`/Url/${shortCode}`);
}
